// Padel Eagle Styleguide & CI 2027 - single source for brand tokens.
export const PE = {
  bordeaux: "#743444", // headings H1-H3, Performer stage
  orange: "#E49421", // main buttons, Competitor stage, highlights
  peach: "#F4C48B", // Builder stage, chips, awards
  mauve: "#74586C", // the only body-text color, button hover
  lightOrange: "#EFB058",
  sand: "#F9F4EB",
  roseLight: "#D8C4C1", // dividers, form borders
  rose: "#B79498", // secondary info, placeholders
  oldRose: "#95646E", // subtle accents only, never buttons
  white: "#FFFFFF",
  offWhite: "#FAFAFA",
  blush: "#FFF5F0",
  greyStage: "#F2EDE7",
  // Stage resting tones
  peachRest: "#FCEBD3",
  orangeRest: "#FBE5C2",
  bordeauxRest: "#F1DFE2",
  // rgb triplets for rgba() usage
  bordeauxRgb: "116,52,68",
  orangeRgb: "228,148,33",
  peachRgb: "244,196,139",
  mauveRgb: "116,88,108",
  headingFont: '"Varela Round", "Bai Jamjuree", sans-serif',
  bodyFont: '"Bai Jamjuree", "Helvetica Neue", Arial, sans-serif',
  cardRadius: 16,
  tileRadius: 20,
} as const;
